import { addDays, addMinutes, format, parse } from "date-fns";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  DatePicker,
  DesktopTimePicker,
  Divider,
  Grid,
  Loading,
  LocalizationProvider,
  Paper,
  TextField,
  Typography,
} from "../../../components";
import { value } from "../../../helpers";
import { formatPrice } from "../../../utils";
import DateCalendarCustom from "./date-calendar-custom.component";

export default function AgendamentoFormMobile({
  agendamento,
  setAgendamento,
  configuracoes,
  horariosList,
  dataSelecionada,
  setMesSelecionado,
  onChangeDate,
  shouldDisableDate,
  disableMesAnterior,
  disableMesPosterior,
  handleChangeTextfield,
  handleSubmit,
  mensagemErro,
  empresaLabel,
  loading,
}) {
  const fontSize = { xs: "15px", md: "20px" };
  const labelFontSize = { xs: "17px", md: "20px" };

  const renderIntervaloAgendamento = () => {
    const start = agendamento.hora,
      tempoServico = agendamento.tempoServico;
    const dataInicio = parse(start, "HH:mm", new Date());
    const end = addMinutes(dataInicio, tempoServico);
    return `${start} - ${format(end, "HH:mm")}`;
  };

  const formatServicoLabel = (label) => {
    if (label?.length > 24) {
      return `${label.slice(0, 21)}...`;
    }

    return label;
  };

  return (
    <Box
      className="bg-white w-100 d-flex flex-column flex-1 justify-content-around align-items-center"
      sx={{
        minHeight: "100dvh",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          px: 2,
          mt: 5,
          mb: 2,
          maxWidth: "100dvh",
        }}
      >
        <Typography
          color="primary"
          variant="h1"
          className="text-uppercase fw-bolder"
          sx={{
            fontSize: {
              xs: 24,
              md: 40,
            },
            lineHeight: 1.2,
            textAlign: "center",
          }}
        >
          Agendamento de Serviço
        </Typography>
      </Box>
      {mensagemErro ? (
        <Card className="mb-4 rounded-4 p-2" sx={{ maxWidth: "70%" }}>
          <CardContent>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "24px",
                textAlign: "center",
                lineHeight: "1.3",
              }}
              className="mb-4"
            >
              {mensagemErro.includes("sucesso")
                ? "Agendamento Concluído"
                : "Agendamento Indisponível"}
            </Typography>
            <Typography
              variant="body1"
              color="textSecondary"
              className="mb-3"
              sx={{ fontSize: "20px", textAlign: "justify", lineHeight: "1.2" }}
            >
              {mensagemErro}
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <div className="d-flex flex-column gap-3 mx-4 mt-3 w-100 justify-content-center">
          <div className="mx-2">
            <DateCalendarCustom
              value={dataSelecionada}
              shouldDisableDate={shouldDisableDate}
              onMonthChange={(value) =>
                setMesSelecionado(new Date(value).toISOString())
              }
              onChange={(value) => onChangeDate("data", value)}
              minDate={new Date()}
              maxDate={addDays(new Date(), 30)}
              disabledPrevMonth={disableMesAnterior()}
              disabledNextMonth={disableMesPosterior()}
            />
          </div>
          <Divider
            sx={{ mt: 1, mb: 3, border: "1px solid grey", width: "100%" }}
          />
          {configuracoes.intervaloAgendamentos !== "null" ? (
            horariosList.length ? (
              <div className="d-flex flex-row justify-content-center mx-4">
                <Grid container spacing={2}>
                  {horariosList.map((item, index) => (
                    <Grid
                      key={index}
                      item
                      xs={4}
                      md={2}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Chip
                        key={index}
                        label={item}
                        clickable
                        onClick={() =>
                          setAgendamento((prev) => ({
                            ...prev,
                            hora: item,
                          }))
                        }
                        color={
                          agendamento?.hora === item ? "primary" : "default"
                        }
                        variant={
                          agendamento?.hora === item ? "filled" : "outlined"
                        }
                        sx={{
                          fontSize: { xs: "15px", md: "20px" },
                          padding: { xs: "19px", md: "22px" },
                          width: { sx: "90px", md: "120px" },
                          justifyContent: "center",
                          "& .MuiChip-label": {
                            px: 1,
                            whiteSpace: "nowrap",
                            width: "100%",
                            textAlign: "center",
                          },
                          transition: "all 0.2s ease-in-out",
                          "&:hover": {
                            transform: "translateY(-1px)",
                            boxShadow: 1,
                          },
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </div>
            ) : (
              <div className="d-flex justify-content-center">
                <Typography
                  variant="h6"
                  sx={{ fontSize, fontWeight: 600, color: "#a99" }}
                >
                  Sem horários disponíveis
                </Typography>
              </div>
            )
          ) : (
            <Grid container spacing={4} className="px-4">
              <Grid item xs={6}>
                <DatePicker
                  id="data"
                  name="data"
                  label="Data"
                  format="dd/MM/yyyy"
                  disabled
                  value={value.date(dataSelecionada)}
                />
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider>
                  <DesktopTimePicker
                    sx={{ width: "100%" }}
                    name="hora"
                    label="Hora"
                    disabled={!agendamento?.data}
                    onChange={(time) => {
                      if (!time) return;
                      setAgendamento((prev) => ({
                        ...prev,
                        hora:
                          time != "Invalid Date" ? format(time, "HH:mm") : null,
                      }));
                    }}
                    value={
                      agendamento?.hora
                        ? parse(agendamento.hora, "HH:mm", new Date())
                        : null
                    }
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          )}
          <Divider sx={{ my: 3, border: "1px solid grey", width: "100%" }} />
          <Grid container spacing={2} alignItems="stretch">
            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: "flex", mb: { xs: 3, md: 0 } }}
            >
              <TextField
                id="observacao"
                name="observacao"
                label="Observação"
                variant="outlined"
                value={agendamento?.observacao ?? ""}
                onChange={handleChangeTextfield}
                InputLabelProps={{
                  sx: {
                    fontSize: { xs: "18px", md: "22px" },
                    marginTop: "-4px",
                  },
                }}
                InputProps={{
                  sx: {
                    "& .MuiInputBase-input": {
                      fontSize: {
                        xs: "15px !important",
                        md: "20px !important",
                      },
                    },
                  },
                }}
                fullWidth
                multiline
                rows={3}
                sx={{
                  flex: 1,
                  height: "100%",
                  mx: 3,
                  "& .MuiInputBase-root": {
                    height: "100%",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
              <Paper
                className="py-4 px-3 mx-4 text-white text-center d-flex flex-column gap-3"
                elevation={2}
                sx={{
                  backgroundColor: "#4da4ec2f",
                  flex: 1,
                  borderRadius: 4,
                }}
              >
                <div className="d-flex flex-row justify-content-between">
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: labelFontSize,
                      fontWeight: 400,
                    }}
                  >
                    Horário
                  </Typography>
                  {agendamento.hora && (
                    <Typography
                      variant="h6"
                      sx={{ fontSize: labelFontSize, fontWeight: 600 }}
                    >
                      {renderIntervaloAgendamento()}
                    </Typography>
                  )}
                </div>
                <div className="d-flex flex-row justify-content-between">
                  <Typography
                    variant="h6"
                    sx={{ fontSize: labelFontSize, fontWeight: 400 }}
                  >
                    {formatServicoLabel(agendamento?.servicoNome)}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontSize: labelFontSize, fontWeight: 600 }}
                  >
                    {formatPrice(agendamento.precoServico)}
                  </Typography>
                </div>
              </Paper>
            </Grid>
          </Grid>
          <Button
            variant="contained"
            className="fw-bold rounded-3"
            disableElevation
            color="primary"
            onClick={handleSubmit}
            disabled={!agendamento.data || !agendamento.hora}
            sx={{
              width: "fit-content",
              alignSelf: "center",
              fontSize: { xs: "15px", md: "18px" },
              marginTop: { xs: 3, md: 5 },
            }}
          >
            Confirmar Agendamento
          </Button>
        </div>
      )}
      <div className="d-flex flex-column align-items-center w-100">
        <Divider sx={{ my: 3, border: "1px solid grey", width: "100%" }} />
        <Box
          sx={{
            px: 2,
            mb: 3,
          }}
        >
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{
              fontSize: {
                xs: 13,
                md: 18,
              },
              lineHeight: 1.2,
            }}
          >
            {empresaLabel}
          </Typography>
        </Box>
      </div>
      <Loading loading={loading} />
    </Box>
  );
}
